import React, { useRef, useState } from 'react'
import {
  message,
  Form,
  AutoComplete,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Button,
  Progress
} from 'antd'
import DataServices from '../../Services/DataServices'
import IntlMessages from '../../util/IntlMessages'
import { useSelector, useDispatch } from 'react-redux'
import Spinner from 'reactstrap/lib/Spinner'
import CheckImage from '../../assets/images/checkimage.jpg'
import CancelImage from '../../assets/images/cancelcheck.png'
import {
  loadPaymentStatusModalShow,
  loadPaymentTypesModalShow,
  loadPaymentStatusData
} from '../../appRedux/actions/CommonData'
import {
  loadSalePaymentStatus,
  loadIsShowCompleteSale
} from '../../appRedux/actions/Sell'
import {
  loadIsPaymentPanelLoading,
  loadEarnedLoyalty
} from '../../appRedux/actions/MainSale'
import PaymentStatusModal from './PaymentStatusModal'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import {
  isEmptyObject,
  notAllowMsgCheck,
  getDecryptID,
  customParse,
  getNotificationHeader,
  paymentDoneCall
} from '../../appRedux/actions'
import { PAY_PAY_MODE } from '../../constants/StoreSetting'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from '../../appRedux/actions/IndexDBActions'
import moment from 'moment'

const PaymentTypesModal = props => {
  const { isRefund, returnStoreCredit, visible_reg, cancelShow, storeReqID } =
    props
  const noOfOutlet = props.noOfOutlet ? props.noOfOutlet : false
  const noOfReg = props.noOfReg ? props.noOfReg : false
  const id = props.id ? props.id : false
  const isSellScreen = props.isSellScreen ? props.isSellScreen : false
  const periodFreq = props.periodFreq ? props.periodFreq : false
  const mode = props.mode ? props.mode : false
  const timerIdRef = useRef(null)

  const delay = 5000 // 5 seconds in milliseconds
  const interval = 3000 // 3 seconds in milliseconds

  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxPaymentTypesModalShow = useSelector(
    ({ commonConfigs }) => commonConfigs.paymentTypesModalShow
  )
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const getReduxSaleScreenProcessing = useSelector(
    ({ Sell }) => Sell.isSalePaymentDone
  )
  const getEarnedLoyalty = useSelector(
    ({ MainSale }) => MainSale.getEarnedLoyalty
  )
  const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getRefundSaleStatus = useSelector(({ Sell }) => Sell.refundSaleStatus)
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getAccLaybyCreditAmount = useSelector(
    ({ MainSale }) => MainSale.getAccLaybyCreditAmount
  )
  const getStorePaymentTypes = useSelector(
    ({ MainSale }) => MainSale.getStorePaymentTypes
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsStoreCreditEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsStoreCreditEnabled
  )
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getIsPaymentPanelLoading = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelLoading
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const formAmountToPay = useSelector(({ MainSale }) => MainSale.amountToPay)

  const [getpaymentTypes, setpaymentTypes] = React.useState([])
  const [getPaymentGateway, setPaymentGateway] = React.useState('')
  const [getIsLoading, setIsLoading] = React.useState(true)
  const [getIsMounted, setIsMounted] = React.useState(true)
  const [visible, setVisible] = React.useState(false)
  const [session, setSession] = React.useState('')
  const [payTypeID, setPayTypeID] = React.useState('')
  // const [getIsRefundSale, setIsRefundSale] = React.useState(false);

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (isSellScreen) {
        if (isOnline)
          //  && getCurrentSalesOrderData.key
          getPaymentTypesService('0', mounted)
        else loadIndexDBPayments()
      } else {
        if (mode == PAY_PAY_MODE.SUBSCRIPTION) {
          getPaymentTypesService('1', mounted)
        } else if (mode == PAY_PAY_MODE.REGISTRATION_SUBSCRIPTION) {
          getPaymentTypesService('1', mounted)
        }
      }
    }

    return () => {
      //memory cleaning func --> to resolve memory leakage
      mounted = false
      setIsMounted(false)
    }
  }, [])

  React.useEffect(() => {
    let timer
    let mounted = true
    //self calling func for resp checking for sale screen
    if (getReduxSaleScreenProcessing && mounted) {
      ;(function loopCheckResponseForSell () {
        let localRespData = localStorage.getItem('statusresponse')
        if (localRespData && localRespData != '') {
          let data = JSON.parse(localRespData)
          localStorage.setItem('statusresponse', '') // this is for the stopping of loop for localStorage check
          dispatch(loadSalePaymentStatus(false)) // this is for the stopping of loop for paymentTypesModal
          dispatch(loadPaymentStatusData(data))
          dispatch(loadPaymentStatusModalShow(true))
          if (data && data.mode == '2') {
            dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
          }
        } else {
          timer = setTimeout(() => {
            loopCheckResponseForSell()
          }, 6000)
        }
      })()
    }

    return () => {
      mounted = false
      clearTimeout(timer)
    }
  }, [getReduxSaleScreenProcessing])

  React.useEffect(() => {
    let mounted = true
    let refundStatus = getRefundSaleStatus
    //0 = Not Refund, 1 = Refund Allow, 2 = Already Refunded
    if (mounted) {
      if (refundStatus == 1) {
        // setIsRefundSale(true);
      } else if (refundStatus == 2) {
      }
    }
    return () => (mounted = false)
  }, [getRefundSaleStatus])

  function loadIndexDBPayments () {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.PAYMENTTYPES
    )
    data
      .then(e => {
        setIsLoading(false)
        if (e && e.length > 0) {
          const payBodies = []
          e.map(q => {
            payBodies.push({
              gatewayName: q.gatewayName ? q.gatewayName : null,
              gatewayURL: null,
              paymentTypeName: q.paymentTypeName ? q.paymentTypeName : '',
              sPaymentTypeId: q.paymentTypeID
                ? `${q.paymentTypeID}&&_7d47-0184-4d52-90f1-33fd0a48a5c0`
                : '',
              sourcePay: q.paymentTypeSourceID
                ? getDecryptID(q.paymentTypeSourceID)
                : null
            })
          })
          setpaymentTypes(payBodies)
        }
      })
      .catch(e => {
        setIsLoading(false)
        console.log(
          'INDEX_DB_ERROR -> getIndexDBCustomerGroups, index api call CUSTOMERGROUPS -->',
          e
        )
      })
  }

  async function getPaymentTypesService (isMain, isMounted) {
    const createReq = DataServices.getCommonPaymentTypesService(
      isMain,
      BEHAVIOUR_TYPE.GET
    )
    await createReq
      .then(res => {
        if (isMounted && getIsMounted) {
          setIsLoading(false)
          if (res && res.length > 0) {
            setpaymentTypes(res)
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        // console.error("PayReqStatus", e);
        // message.error("Failed, report this & Try later");
      })
  }

  async function getPayTypesNonAuthService (body) {
    const createReq = DataServices.getPayTypesNonAuth(body, BEHAVIOUR_TYPE.GET)
    await createReq
      .then(res => {
        if (res) {
          dispatch(loadSalePaymentStatus(true))
          window.open(res)
        }
        dispatch(loadIsPaymentPanelLoading(false))
      })
      .catch(e => {
        setIsLoading(false)
        dispatch(loadIsPaymentPanelLoading(false))
        dispatch(loadSalePaymentStatus(false))
        console.error('reg_sub_PayPalReq', e)
        message.error('Failed, report this & Try later')
      })
  }

  function onPayRegSubClick (data) {
    const gateway = data.gatewayName
    localStorage.setItem('openwindow', '1')
    setIsLoading(true)
    setPaymentGateway(data.gatewayName)
    let body = {
      gateway: gateway,
      mode: mode,
      value: `${storeReqID}&&45_YRD64_AJSD5_POIU77_ASD86`,
      amount: 0,
      paymentType: getDecryptID(data.sPaymentTypeId)
    }
    getPayTypesNonAuthService(body)
  }

  function getOffPay (currBody) {
    return {
      isOk: true,
      isPaid: true,
      alreadyCompleted: 0,
      paymentTypeID: currBody.PaymentTypeID,
      amount: currBody.PaymentAmount ? currBody.PaymentAmount : 0,
      // currency: 0,
      gateway: 'cash',
      paymentOn: moment(),
      paymentOnShort: moment().format('MM/DD/YYYY h:mm A'),
      message: 'Payment  done succeessfully',
      // paymentIdentifier: 0,
      // session: 0,
      // mode: 0,
      earnedLoyalty: 0
      // status: 0
    }
  }

  function callToPayment (res, body, indexKey) {
    paymentDoneCall(
      res,
      getCurrentSalesOrderStatusID,
      getEarnedLoyalty,
      getCustomerSearchData,
      body,
      getStorePaymentTypes,
      getDefaultDecimalPlaces,
      getIsRefundSale,
      returnStoreCredit,
      getIsLoyaltyEnabled,
      getIsStoreCreditEnabled,
      dispatch
    )
    dispatch(loadIsPaymentPanelLoading(false))
  }

  // const CalculateOFFLinePay = (indexKey, body) => {
  //   if (indexKey) {
  //     const data = GetIndexDBDataByTableName(
  //       INDEX_DB_NAME,
  //       INDEX_DB_TABLES.SALE_PAY
  //     )
  //     data
  //       .then(e => {
  //         let bodys = []
  //         const payExist = e.filter(er => er.indexKey == indexKey)
  //         if (payExist && payExist.length > 0) {
  //           bodys = payExist[0].payBodys
  //         }
  //         bodys.push(body)
  //         const postIndexBody = [
  //           {
  //             indexKey: indexKey,
  //             payBodys: bodys
  //           }
  //         ]

  //         const res = getOffPay(body)
  //         callToPayment(res, body, indexKey)
  //         saveEntitiesDatatoIndexBD(
  //           postIndexBody,
  //           INDEX_DB_NAME,
  //           CURRENT_VERSION,
  //           INDEX_DB_TABLES.SALE_PAY,
  //           'CalculateOFFLinePay'
  //         )
  //       })
  //       .catch(e => {
  //         console.log('INDEX_DB -> CalculateOFFLinePay -->', e)
  //       })
  //   }
  // }

  const CalculateOFFLinePay = async (indexKey, body) => {
    if (indexKey) {
      const data = GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        INDEX_DB_TABLES.SALES
      )
      data
        .then(async e => {
          let bodys = []
          const payExist = e.filter(er => er.indexKey == indexKey)
          if (payExist && payExist.length > 0) {
            const sale = payExist[0]
            let postBody = { ...body }
            postBody.indexKey = indexKey
            postBody.datetime = moment().format()
            if (sale.payBodys && sale.payBodys.length > 0) {
              bodys = sale.payBodys
            }
            bodys.push(postBody)
            let post_sale = { ...sale }
            post_sale.payBodys = bodys
            post_sale.isOffline = true
            await saveEntitiesDatatoIndexBD(
              [post_sale],
              INDEX_DB_NAME,
              CURRENT_VERSION,
              INDEX_DB_TABLES.SALES,
              'CalculateOFFLinePay'
            )

            const res = getOffPay(postBody)
            setTimeout(() => {
              callToPayment(res, postBody, indexKey)
            }, 1000)
          }
        })
        .catch(e => {
          console.log('INDEX_DB -> CalculateOFFLinePay -->', e)
          dispatch(loadIsPaymentPanelLoading(false))
        })
    }
  }

  async function postSalesOrderPayments (body) {
    const cashRegPay = localStorage.getItem('cashManageID')
    if (cashRegPay && cashRegPay != '') {
      body.CashRegPaymentID = cashRegPay
      if (isOnline && body.SalesOrderID) {
        const postSalePaymentData = DataServices.postSalePaymentData(
          body,
          BEHAVIOUR_TYPE.POST,
          'PaymentTypesModal'
        )
        await postSalePaymentData
          .then(res => {
            dispatch(loadIsPaymentPanelLoading(false))
            if (res) {
              callToPayment(res, body)

              // // // if account sale's payment done
              // if (res.alreadyCompleted) {
              //   message.info('Sale has already been completed', 4)
              // }
              // if (
              //   getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
              //   getDecryptID(getCurrentSalesOrderStatusID) == '2'
              // ) {
              //   let customerData = getCustomerSearchData
              //   if (customerData && !isEmptyObject(customerData)) {
              //     const toCut = body.PaymentAmount
              //       ? body.PaymentAmount
              //       : body.paymentAmount
              //       ? body.paymentAmount
              //       : 0
              //     const cusAccCredit = customerData.accountCredit
              //       ? customerData.accountCredit
              //       : 0
              //     const resValue = cusAccCredit - toCut
              //     customerData.accountCredit = resValue < 0 ? 0 : resValue
              //   }
              //   ApplyCustomerAccountDetails(
              //     dispatch,
              //     customerData,
              //     getStorePaymentTypes,
              //     getDefaultDecimalPlaces,
              //     getIsRefundSale,
              //     returnStoreCredit,
              //     getIsLoyaltyEnabled,
              //     getIsStoreCreditEnabled
              //   )
              // }
              // // if (getDecryptID(getCurrentSalesOrderStatusID) == "1" || getDecryptID(getCurrentSalesOrderStatusID) == "2") {
              // //   let customerData = getCustomerSearchData;
              // //   const customer = onAccLayBySaleEffects( // this effect only accCredit of customer
              // //     customerData,
              // //     getAccLaybyCreditAmount,
              // //     formAmountToPay,
              // //     false,
              // //     dispatch,
              // //   );
              // //   if (customer && !isEmptyObject(customer)) {
              // //     customerData = customer;
              // //   }
              // //   ApplyCustomerAccountDetails(
              // //     dispatch,
              // //     customerData,
              // //     getStorePaymentTypes,
              // //     getDefaultDecimalPlaces,
              // //     getIsRefundSale,
              // //     returnStoreCredit,
              // //     getIsLoyaltyEnabled,
              // //     getIsStoreCreditEnabled,
              // //   );
              // // }
              // dispatch(loadPaymentStatusData(res))
              // dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
              // if (res.earnedLoyalty > 0) {
              //   dispatch(loadEarnedLoyalty(getEarnedLoyalty + res.earnedLoyalty))
              // } else {
              //   dispatch(loadEarnedLoyalty(0))
              // }
            }
          })
          .catch(e => {
            notAllowMsgCheck(e)
            dispatch(loadIsPaymentPanelLoading(false))
            setIsLoading(false)
          })
      } else {
        CalculateOFFLinePay(
          getCurrentSalesOrderData && getCurrentSalesOrderData.indexKey
            ? getCurrentSalesOrderData.indexKey
            : false,
          body
        )
      }
    } else {
      message.warn('Unable to pay ...')
    }
  }

  //self calling func for resp checking for billing
  if (getReduxPaymentTypesModalShow) {
    ;(function loopCheckResponse () {
      let localRespData = localStorage.getItem('statusresponse')
      if (localRespData && localRespData != '') {
        //salis amount gateway ...

        let data = JSON.parse(localRespData)
        dispatch(loadPaymentStatusData(data))
        dispatch(loadPaymentStatusModalShow(true))
      } else {
        window.setTimeout(loopCheckResponse, 3000)
      }
    })()
  }

  function startTimer (fromState, payID_, sessID_) {
    // Call the function after the delay
    timerIdRef.current = setTimeout(() => {
      const payID = fromState ? payTypeID : payID_
      const sessID = fromState ? session : sessID_
      let first = true
      callToTrustStatus(payID, sessID)
      // Call the function again every `interval` milliseconds
      timerIdRef.current = setInterval(
        // first ? '' : callToTrustStatus(payID, sessID),
        interval
      )
    }, delay)
  }

  // function dummyPay (payID, sessID) {
  //   const res = {
  //     alreadyCompleted: false,
  //     amount: 3.5,
  //     currency: null,
  //     earnedLoyalty: 0,
  //     gateway: 'trustly',
  //     isOk: true,
  //     isPaid: true,
  //     message: null,
  //     mode: '2',
  //     paymentIdentifier: '',
  //     paymentOn: '2023-04-20T21:11:07',
  //     paymentOnShort: '04/20/2023 9:11 PM',
  //     session: '654Asda',
  //     status: 1
  //   }
  //   if (res) {
  //     if (res.status == 1) {
  //       // success
  //       dispatch(loadPaymentStatusData(res))
  //       message.success('Payment has been done successfully')
  //       stopTimer()
  //       setPayTypeID('')
  //       setSession('')
  //       dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
  //       dispatch(loadIsPaymentPanelLoading(false))
  //     } else if (res.status == 2) {
  //       startTimer(false, payID, sessID)
  //       message.info('Payment pending, ask customer to pay', 4)
  //     } else {
  //       setVisible(true)
  //       stopTimer()
  //       dispatch(loadIsPaymentPanelLoading(false))
  //     }
  //   } else {
  //     setVisible(true)
  //     stopTimer()
  //     dispatch(loadIsPaymentPanelLoading(false))
  //   }
  // }

  function stopTimer () {
    clearTimeout(timerIdRef.current)
    clearInterval(timerIdRef.current)
  }

  function callToTrustStatus (payID, sessID) {
    const createReq = DataServices.getTrustStatusService(payID, sessID)
    createReq
      .then(res => {
        if (res) {
          if (res.message && res.message == 'Cancelled') {
            setVisible(false)
            setPayTypeID('')
            setSession('')
            stopTimer()
            dispatch(loadIsPaymentPanelLoading(false))
            getNotificationHeader(
              dispatch,
              'Payment has been cancelled',
              3000,
              'error'
            )
          } else if (res.status == 1) {
            // success
            dispatch(loadPaymentStatusData(res))
            getNotificationHeader(
              dispatch,
              'Payment has been done successfully',
              3000,
              'success'
            )
            stopTimer()
            setPayTypeID('')
            setSession('')
            dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
            dispatch(loadIsPaymentPanelLoading(false))
          } else if (res.status == 2) {
            setTimeout(() => {
              callToTrustStatus(payID, sessID)
            }, interval)
            getNotificationHeader(
              dispatch,
              'Payment pending, ask customer to pay',
              3000,
              'info'
            )
          } else {
            setVisible(true)
            stopTimer()
            dispatch(loadIsPaymentPanelLoading(false))
          }
        } else {
          setVisible(true)
          stopTimer()
          dispatch(loadIsPaymentPanelLoading(false))
        }
      })
      .catch(e => {
        setVisible(true)
        stopTimer()
        setIsLoading(false)
        dispatch(loadIsPaymentPanelLoading(false))
        dispatch(loadSalePaymentStatus(false))
        console.error('callToTrustStatus', e)
        message.error('Payment Failed')
      })
  }

  const ConfirmRetry = () => {
    return (
      <Modal
        title={<h1>Payment Failed</h1>}
        visible={visible}
        onOk={() => {
          dispatch(loadIsPaymentPanelLoading(true))
          startTimer(true)
        }}
        okText='Retry'
        onCancel={() => {
          if (!getIsPaymentPanelLoading) {
            setVisible(false)
            setPayTypeID('')
            setSession('')
          }
        }}
        centered={true}
        width={'402px'}
        // footer={null}
      >
        <Spin spinning={getIsPaymentPanelLoading} size='large'>
          <h3>Payment Failed, Do you want to retry?</h3>
        </Spin>
      </Modal>
    )
  }

  function payPalReqService (gateway, mode, id, amount, paymentTypeID) {
    const createReq = DataServices.createPayPalReqService(
      gateway,
      mode,
      id,
      amount,
      paymentTypeID
    )
    createReq
      .then(res => {
        if (res) {
          if (gateway == 'trustly') {
            setPayTypeID(paymentTypeID)
            setSession(res)
            return startTimer(false, paymentTypeID, res)
          } else {
            //   this.setState({ getLinkUrl: res });
            dispatch(loadSalePaymentStatus(true)) // isSalePaymentDone
            window.open(res)
          }
        }
        dispatch(loadIsPaymentPanelLoading(false))
      })
      .catch(e => {
        setIsLoading(false)
        dispatch(loadIsPaymentPanelLoading(false))
        dispatch(loadSalePaymentStatus(false))
        console.error('PayPalReq', e)
        message.error('Failed, report this & Try later')
      })
  }

  async function createPayReService (body, gatewayName, paymentTypeID) {
    const createReq = DataServices.createSubPaymentReqService(body)
    await createReq
      .then(res => {
        if (res) {
          let gateway = gatewayName
          let modeName = mode //for subscription
          let id = res
          payPalReqService(gateway, modeName, id, 0, paymentTypeID) //For Subscription amount do not need to sent
        }
      })
      .catch(e => {
        setIsLoading(false)
        console.error('createSubPayment', e)
        message.error('Failed, report this & Try later')
      })
  }

  function onPayClick (data) {
    localStorage.setItem('openwindow', '1')
    localStorage.setItem('gatewaypost', '')
    if (isSellScreen) {
      const allowCheck =
        getReduxSalePaymentData && getReduxSalePaymentData.amount != undefined
      if (allowCheck) {
        dispatch(loadIsPaymentPanelLoading(true))
        if (
          data.gatewayName &&
          data.gatewayName != '' &&
          data.gatewayName.toLowerCase() == 'cash'
        ) {
          let body = {
            BehaviorName: 1,
            SalesOrderID: getReduxSalePaymentData.orderGuidID
              ? getReduxSalePaymentData.orderGuidID
              : '',
            PaymentTypeID: data.sPaymentTypeId,
            PaymentAmount: customParse(getReduxSalePaymentData.amount),
            CustomerID:
              getCustomerObj && !isEmptyObject(getCustomerObj)
                ? getCustomerObj.customerSId
                : ''
          }
          postSalesOrderPayments(body)
        } else {
          const gateway = data.gatewayName
          const modeName = mode //for subscription
          const id = getReduxSalePaymentData.orderGuidID
          const amount = getReduxSalePaymentData.amount
          const paymentTypeID = getDecryptID(data.sPaymentTypeId)
          payPalReqService(gateway, modeName, id, amount, paymentTypeID)
          // dispatch(loadSalePaymentStatus(true));
          localStorage.setItem('statusresponse', '') // this is for the stopping of loop on paymentTypesModal
          const cashRegPay = localStorage.getItem('cashManageID')
          if (cashRegPay && cashRegPay != '') {
            const body = {
              BehaviorName: 1,
              SalesOrderID: getReduxSalePaymentData.orderGuidID,
              PaymentTypeID: data.sPaymentTypeId,
              SourcePay: data.sourcePay,
              PaymentAmount: customParse(getReduxSalePaymentData.amount),
              CashRegPaymentID: cashRegPay,
              CustomerID:
                getCustomerObj && !isEmptyObject(getCustomerObj)
                  ? getCustomerObj.customerSId
                  : ''
            }
            localStorage.setItem('gatewaypost', JSON.stringify(body)) // after successfully done entry in store db
          }
        }
      }
    } else {
      setIsLoading(true)
      setPaymentGateway(data.gatewayName)
      let body = {
        NoOfOutlets: parseInt(noOfOutlet),
        NoOfRegisters: noOfReg,
        PackageId: `${id}&&45_YRD64_AJSD5_POIU77_ASD86`,
        PackageTypeFrequency: periodFreq
      }
      createPayReService(
        body,
        data.gatewayName,
        getDecryptID(data.sPaymentTypeId)
      )
    }
  }

  return (
    <>
      <ConfirmRetry />
      <PaymentStatusModal />
      {isSellScreen ? (
        <>
          {getIsLoading ? (
            <div style={{ marginLeft: '46%' }}>
              <Spin spinning={true} />
            </div>
          ) : getIsRefundSale || !isOnline ? (
            getpaymentTypes &&
            getpaymentTypes
              .filter(e => e.gatewayName.toLowerCase() == 'cash')
              .map((e, key) => {
                return (
                  <Button
                    key={key}
                    value={e.paymentTypeSId}
                    className='dk-btn-add btn--payment-type dk-mgr-4 dk-color--red'
                    type='primary'
                    block
                    onClick={() => onPayClick(e)}
                    // onClick={() => handleSaleCompletePanelActive(true)}
                  >
                    {e.paymentTypeName}
                  </Button>
                )
              })
          ) : (
            getpaymentTypes &&
            getpaymentTypes
              .filter(
                e =>
                  e.gatewayName.toLowerCase() !== 'storecredit' &&
                  e.gatewayName.toLowerCase() !== 'loyalty'
              )
              .map((e, key) => {
                return (
                  <Button
                    key={key}
                    value={e.paymentTypeSId}
                    className='dk-btn-add btn--payment-type dk-mgr-4 dk-color--green '
                    type='primary'
                    block
                    onClick={() => onPayClick(e)}
                    // onClick={() => handleSaleCompletePanelActive(true)}
                  >
                    {e.paymentTypeName}
                  </Button>
                )
              })
          )}
        </>
      ) : (
        <>
          {mode == PAY_PAY_MODE.SUBSCRIPTION && (
            <Modal className='PaymentDetails-modal'
              title={'Payment Details'}
              visible={getReduxPaymentTypesModalShow}
              okText={<IntlMessages id='setup.paymentTypes.beginSetup' />}
              // width={700}
              centered={true}
              footer={null}
              onCancel={() => {
                dispatch(loadPaymentTypesModalShow(false))
                setIsLoading(false)
                // this.setState({ getLinkUrl: "" });
                // this.setState({ visible: false });
                // this.setState({ isBillingLoading: false });
              }}
              cancelButtonProps={{
                className: 'dk-btn-cancel'
              }}
            >
              <Spin
                tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                spinning={getIsLoading}
                size='large'
              >
                <div>
                  <Row justify='center' className='col-lr-space'>
                    {getpaymentTypes &&
                      getpaymentTypes.length > 0 &&
                      getpaymentTypes.map((e, key) => {
                        return (
                          <Col key={key}>
                            <Button
                              onClick={() => onPayClick(e)}
                              className='dk-btn-add'
                              type='primary'
                              size='large'
                            >
                              {e.paymentTypeName}
                            </Button>
                          </Col>
                        )
                      })}
                  </Row>
                </div>
              </Spin>
            </Modal>
          )}

          {mode == PAY_PAY_MODE.REGISTRATION_SUBSCRIPTION && (
            <Modal className='PaymentDetails-modal'
              title={'Payment Details'}
              visible={visible_reg}
              // okText={<IntlMessages id='setup.paymentTypes.beginSetup' />}
              // width={700}
              centered={true}
              footer={null}
              onCancel={() => {
                cancelShow()
                setIsLoading(false)
                // this.setState({ getLinkUrl: "" });
                // this.setState({ visible: false });
                // this.setState({ isBillingLoading: false });
              }}
              cancelButtonProps={{
                className: 'dk-btn-cancel'
              }}
            >
              <Spin tip={'Loading'} spinning={getIsLoading} size='large'>
                <div>
                  <Row justify='center' className='col-lr-space'>
                    {getpaymentTypes &&
                      getpaymentTypes.length > 0 &&
                      getpaymentTypes.map((e, key) => {
                        return (
                          <Col key={key}>
                            <Button
                              onClick={() => onPayRegSubClick(e)}
                              className='dk-btn-add'
                              type='primary'
                              size='large'
                            >
                              {e.paymentTypeName}
                            </Button>
                          </Col>
                        )
                      })}
                  </Row>
                </div>
              </Spin>
            </Modal>
          )}
        </>
      )}
    </>
  )
}

export default PaymentTypesModal
